import React from 'react';
import ActualNewsletterLink from 'components/newsletters/actualNewsletterLink';

const StatusDOI = () => {
  return (
    <div className="col-xs-12 col-md-12 padding-right-xl font-size-xxs leading-text-tight">
      Du bist bereits zu unserem Newsletter angemeldet. Willkommen zurück.
    </div>
  );
};

export default StatusDOI;
